// extracted by mini-css-extract-plugin
export default {"case-details__value--dimmed":"case-details_case-details__value--dimmed__bHRPe","case-details__value--danger":"case-details_case-details__value--danger__96VED"};